export function validateSecureMediaEndpointResponse(input) {
    return (input &&
        typeof input.success === "boolean" &&
        ((input.data &&
            typeof input.data.policy === "string" &&
            typeof input.data.expiresAt === "number" &&
            typeof input.data.resource === "string") ||
            (input.error && typeof input.error.message === "string")));
}
